<ng-container *ngIf="programDetailContent && programDetailContent?.isActive">
  <section class="program-detail-section">
    <div class="box">
      <h2 *ngIf="!!programDetailContent?.heading" class="sub-heading"
        [innerHTML]="programDetailContent?.heading | safeHtml"></h2>
      <div class="content" [innerHTML]="programDetailContent?.description | safeHtml"></div>
      <div class="spacer" role="presentation" aria-hidden="true"></div>
    </div>
  </section>
</ng-container>